module.exports = __webpack_public_path__ + "img/class-room-home.35b71eba.png";